<div>
  <div class="flex items-center justify-center h-[70px]">
    <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium flex items-center">
      Import Work Order
    </h4>
  </div>

  <mat-dialog-content class="!px-10 !pt-0 bg-white">
    <div class="text-xs text-center font-medium mb-4">
      * You can only upload excel file with certain format. Please download the template file
      <a href="assets/files/MDU Build_Template.xlsx" download
      class="text-primary underline font-sans font-semibold">here</a>
    </div>

    <!-- File Upload -->
    <div class="mb-4 w-full">
      <div class="flex justify-center items-center flex-col my-4 h-16 border border-dashed border-gray-400 rounded-lg cursor-pointer"
        (click)="file.click()" role="button" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && file.click()" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && file.click()">
        <img src="../../../../../../assets/icons/upload.svg" alt="" width="20" />

        <div class="flex items-center gap-4">
          <p class="font-sans font-medium text-[12px] text-center">{{ selectedFile.length > 0 ?
          selectedFile[0]?.name : 'Select Excel File' }}</p>
          @if (selectedFile.length > 0) {
            <button (click)="removeFiles($event, file)">
              <img [src]="GridActionButtons.RedDeleteButton.iconName" alt="" height="16" width="16"
                class="cursor-pointer" />
              </button>
            }
          </div>
        </div>
        <input type="file" #file accept=".xlsx, .xls" (change)="onFileSelected($event)" style="display: none;"
          multiple="false" />
        </div>
      </mat-dialog-content>

      <!-- Action Buttons -->
      <mat-dialog-actions class="!p-0 flex !justify-center !mb-3 !mt-3">
        <button mat-stroked-button color="accent" type="button"
        class="!h-[33px] !border !border-primary !bg-transparent !text-primary" (click)="cancel()">Cancel</button>
        <button mat-flat-button class="primary-button" (click)="importFiles()">Import File</button>
      </mat-dialog-actions>
    </div>